





import { ButtonRefreshTs } from './ButtonRefreshTs';
export default class ButtonRefresh extends ButtonRefreshTs {}
